import React,{ useEffect, useState } from "react";
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid';
import { useDispatch } from "react-redux";
import { toast } from 'react-toastify';

import SidebarMenuItem from "./SidebarMenuItem";
import SidebarMenuItemWithSub from "./SidebarMenuItemWithSub";

import { storeMenu } from "../../../../../app/redux/storeMenuUrl";

const SidebarMenuMain = (() => {
    
    const dispatch = useDispatch();

    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;

    const [ allMenuList, setAllMenuList ] = useState([]);

    const getMenuList = async () => {
        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken') 
        }
        else if(loginUserType === 'E'){
            apiToken = localStorage.getItem('agenttoken') 
        }
        const apiHeaders = {
            headers: {
                "x-access-token": apiToken,
            },
        };
        let reqObj = {};
        try {
            await axios.post(`${api_base_url}admin/get-assign-menu-list`, reqObj, apiHeaders)
            .then(async (res) => {
                if(res.data.status === 'success'){
                    if(res.data.data.menu_list.length > 0){
                        setAllMenuList(res.data.data.menu_list)
                    }
                }
                else{
                    toast.error("There is an error");
                }
            })
            .catch((error) => {
                console.error(error);
            })
        } catch (error) {
            console.error("Error during save:", error);
        }
    }
    useEffect(() => {
        getMenuList();
    },[]);
    const [menuHtml, setMenuHtml] = useState(null);
    const [allAssignMenu, setAllAssignMenu] = useState({ menu_urls: [] });
    useEffect(() => {
        if (allMenuList.length > 0) {
            let updatedMenu = [];
            updatedMenu.push({ menu_url: 'settings/business-setup' });
            const generatedMenuHtml = allMenuList.map((allMenu) => {
                let submenuItems = [];
                if (allMenu.submenu_list && allMenu.submenu_list.length > 0) {
                    submenuItems = allMenu.submenu_list.map((submenu) => {
                        updatedMenu.push({ menu_url: submenu.menu_url });
                        return (
                            <SidebarMenuItem 
                                key={uuidv4()}
                                to={submenu.menu_url}
                                title={submenu.menu_name}
                                hasBullet={false}
                            />
                        );
                    });
                    return (
                        <SidebarMenuItemWithSub
                            key={uuidv4()}
                            to={allMenu.menu_name.toLowerCase()}
                            title={allMenu.menu_name}
                            icon={allMenu.menu_icon}
                        >
                            {submenuItems}
                        </SidebarMenuItemWithSub>
                    );
                } else {
                    if(allMenu.menu_url === 'agents'){
                        updatedMenu.push({ menu_url: 'manage-virtual-agent' });
                    }
                    updatedMenu.push({ menu_url: allMenu.menu_url });
                    return (
                        <SidebarMenuItem
                            key={uuidv4()}
                            to={allMenu.menu_url}
                            icon={allMenu.menu_icon}
                            title={allMenu.menu_name}
                        />
                    );
                }
            });
            setMenuHtml(generatedMenuHtml);
            setAllAssignMenu((prevData) => ({
                ...prevData,
                menu_urls: updatedMenu,
            }));
        }
    }, [allMenuList]);

    useEffect(() => {
        if(allAssignMenu.menu_urls.length > 0){
            dispatch(storeMenu(allAssignMenu.menu_urls))
        }
    },[allAssignMenu])

    return (
        <>
            {menuHtml}
            {/* <button onClick={() => dispatch(storeMenu(allAssignMenu))}>Increment</button> */}
            {/* <SidebarMenuItem
                to='/dashboard'
                icon='media/icons/duotune/general/gen001.svg'
                title="Dashboard"
                fontIcon='bi-app-indicator'
            /> */}
            {/* <SidebarMenuItem
                to='/system-user'
                icon='media/icons/duotune/general/gen049.svg'
                title='System User'
                fontIcon='bi-layers'
            /> */}
            {/* <SidebarMenuItem
                to='/agent-setup'
                icon='media/icons/duotune/communication/com014.svg'
                title='Live Assistant'
                fontIcon='bi-layers'
            /> */}
            {/* <SidebarMenuItemWithSub
                to='/report'
                title='Report'
                icon='media/icons/duotune/general/gen005.svg'
                fontIcon='bi-person'
            >
                <SidebarMenuItem to='/report/chat-report' title='CDR Report' hasBullet={true} />
                <SidebarMenuItem to='/report/missed-chat' title='Missed Chat' hasBullet={true} />
            </SidebarMenuItemWithSub> */}
            {/* <SidebarMenuItemWithSub
                to='/analytics'
                icon='media/icons/duotune/graphs/gra012.svg'
                title='Analytics'
                fontIcon='bi-layers'
            > 
                <SidebarMenuItem to='/analytics/bot-analytics' title='Bot Analytics' hasBullet={true} />
                <SidebarMenuItem to='/analytics/chat-analytics' title='Chat Analytics' hasBullet={true} />
                <SidebarMenuItem to='/analytics/agent-analytics' title='Agent Analytics' hasBullet={true} />
            </SidebarMenuItemWithSub> */}
            {/* <SidebarMenuItem
                to='/virtual-agent'
                icon='media/icons/duotune/technology/teh003.svg'
                title="Agent"
                fontIcon='bi-app-indicator'
            /> */}
            {/* <SidebarMenuItem
                to='/manage-widget'
                icon='media/icons/duotune/abstract/abs026.svg'
                title="Manage Widget"
                fontIcon='bi-app-indicator'
            /> */}
            {/* <SidebarMenuItem
                to='/billing'
                icon='media/icons/duotune/finance/fin002.svg'
                title='Billing'
                fontIcon='bi-layers'
            /> */}
        </>
    )
})

export default SidebarMenuMain;